var custom = '_1yw4drqh';
var fill = '_1yw4drqf';
var host = '_1yw4drq5';
var image = '_1yw4drqg';
var padding = {true:'_1yw4drqc',false:'_1yw4drqd'};
var paint = '_1yw4drqe';
var shape = {square:'_1yw4drqa',circle:'_1yw4drqb'};
var size = {xsm:'_1yw4drq6',sm:'_1yw4drq7',md:'_1yw4drq8',lg:'_1yw4drq9'};

export { custom, fill, host, image, padding, paint, shape, size };
//# sourceMappingURL=swatch.css.js.map
